import { DateTime } from 'luxon';
import humanizeDuration from 'humanize-duration';

export const HumanDate = ({unknown, date, className, isOffset, isUtc}) => {

    if(date == null){
        const u = unknown || "NA";
        return <span className={className}>{u}</span>
    }
    const d = isOffset ? DateTime.fromISO(date).toUTC() : DateTime.fromISO(isUtc ? (date + "Z") : date);
    return <span title={d.toString()} className={className}>{d.toRelative()}</span>
}

export const ReadableDate = ({date, unknown, className, isOffset, isUtc, localStringFormat = DateTime.DATETIME_MED}) => {

    if(date == null){
        const u = unknown || "NA";
        return <span className={className}>{u}</span>
    }
    const d = isOffset ? DateTime.fromISO(date).toUTC() : DateTime.fromISO(isUtc ? (date + "Z") : date);
    return <span title={d.toString()} className={className}>{d.toLocaleString(localStringFormat)}</span>
}

export const HumanDuration = ({duration, unknown, className}) => {

    if(duration == null){
        const u = unknown || "N/A";
        return <span className={className}>{u}</span>
    }
    return <span title={duration + " ms"} className={className}>{humanizeDuration(duration, { largest: 2, round: true, delimiter: " and " })}</span>
}